import { InvoiceItem, InvoiceLineItem } from 'wisestep-api';

export const getSubtotal = (items: InvoiceItem[]) =>
  items.reduce(
    (accumulator, item) =>
      accumulator +
      (item.type === 'CLOSURE'
        ? item.closure?.commissionValue || 0
        : +(item.invoiceExtraCharge?.amount || 0)),
    0
  );

export const getSubtotalFromLineItems = (items: InvoiceLineItem[]) =>
  items.reduce((accumulator, item) => accumulator + +(item.amount || 0), 0);
